import { PostForm } from "@/modules/feed/entities/post";
import { useTranslations } from "use-intl";
import { FormInModal } from "@/shared/form/form-in-modal";
import Button, { ButtonProps } from "@/shared/form/button";
import { NotificationOutlined } from "@ant-design/icons";
import { EnabledTokens } from "gql/graphql";
import { useHasAnyAccess } from "@/shared/security";
import { GeneratePostTitle } from "@/modules/ai/features/generate-post-title";

/**
 * `buttonProps` — под разные места: на главной это крупная кнопка над лентой,
 * в шапке «Моих постов» — обычное действие списка.
 */
export function CreateAnnouncementBtn({
  buttonProps,
}: {
  buttonProps?: ButtonProps;
} = {}) {
  const t = useTranslations("Feed");

  // создание поста стало отдельным правом: без него сервер отклонит сохранение,
  // поэтому кнопку не показываем вовсе, а не ведём в форму, которая не сработает
  const canCreatePost = useHasAnyAccess(EnabledTokens.FeedCreate);

  if (!canCreatePost) {
    return null;
  }

  return (
    <FormInModal
      modalProps={{
        width: 900,
        "data-testid": "create-new-announcement-modal",
      }}
      title={t("new announcement")}
      trigger={(open) => (
        <NewAnnouncementBtn
          data-testid="new-announcement-button"
          {...buttonProps}
          onClick={open}
        />
      )}
      form={(close) => (
        <PostForm
          afterSubmit={close}
          GeneratePostTitleButton={GeneratePostTitle}
        />
      )}
    />
  );
}

function NewAnnouncementBtn(props: ButtonProps) {
  const t = useTranslations("Feed");

  return (
    <Button
      className="w-full md:w-auto"
      type="primary"
      size="large"
      icon={<NotificationOutlined />}
      {...props}
    >
      {t("new announcement")}
    </Button>
  );
}
